module.exports = __webpack_public_path__ + "static/media/underline.fc27610f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/underline.svg
// module id = 3712
// module chunks = 7